import Api from "@/helpers/fetch";

export default class UserApi {
    /**
     * Get all users
     * @param {Function} callback - The callback function to handle the response
     */
    static async getAllUsers({callback}) {
        const url = "stakeapi/v1/list-users";
        const res = await Api.fetch({
            url,
            method: "GET",
        });

        if (res) callback(res);
    }

    /**
     * Create a new user
     * @param {Object} params - {username, email, first_name, last_name, assign_ward, assign_organization, assign_position}
     * @param {Function} callback - The callback function to handle the response
     * @param {Function} errCallback - The callback function to handle errors
     */
    static async createUser({params, callback, errCallback}) {
        const url = "stakeapi/v1/create-user";
        const res = await Api.fetch({
            url,
            method: "POST",
            params,
        });

        if (res) callback(res);
        else errCallback?.(res);
    }


    /**
     * Get organizations list 
     * @param {Function} callback - The callback function to handle the response
     */
    static async getOrganizations({callback}) {
        const url = "stakeapi/v1/list-organizations";
        const res = await Api.fetch({
            url,
            method: "GET",
        });

        if (res) callback(res);
    }

    /**
     * Get organization positions
     * @param {Object} query - {organization_id}
     * @param {Function} callback - The callback function to handle the response
     */
    static async getOrganizationPositions({query, callback}) {
        const url = "stakeapi/v1/list-positions?organization_id=" + query.organization_id;
        const res = await Api.fetch({
            url,
            method: "GET",
        });

        if (res) callback(res);
    }

    /**
     * Update user details
     * @param {Object} params - {user_id, username, email, first_name, last_name, assign_ward, assign_organization, assign_position}
    * @param {Function} callback - The callback function to handle the response
     * @param {Function} errCallback - The callback function to handle errors
     */
    static async updateUser({params, callback, errCallback}) {
        const url = "stakeapi/v1/update-user";
        const res = await Api.fetch({
            url,
            method: "POST",
            params,
        });

        if (res) callback(res);
        else errCallback?.(res);
    }

    /**
     * Delete a user
     * @param {Object} params - {user_id}
     * @param {Function} callback - The callback function to handle the response
     * @param {Function} errCallback - The callback function to handle errors
     */
    static async deleteUser({params, callback, errCallback}) {
        const url = "stakeapi/v1/delete-user";
        const res = await Api.fetch({
            url,
            method: "POST",
            params,
        });

        if (res) callback(res);
        else errCallback?.(res);
    }

    /**
     * Change user password
     * @param {Object} params - {user_id, new_password}
     * @param {Function} callback - The callback function to handle the response
     * @param {Function} errCallback - The callback function to handle errors
     */
    static async changePassword({params, callback, errCallback}) {
        const url = "stakeapi/v1/change-password";
        const res = await Api.fetch({
            url,
            method: "POST",
            params,
        });

        if (res) callback(res);
        else errCallback?.(res);
    }
}
